export enum ConnectionType {
    Default,
    Domain,
    System, // Bronsysteem / Doelsysteem
}
